<!--  -->
<template>
  <div class="pattern">
    <div class="patternCont">
      <svg-icon icon-class="vip2" class-name="card-panel-icon" />
      <!-- <p>{{ versionTitle }}（剩余{{ tips }}）</p> -->
      <p>{{ versionTitle }}</p>
      <el-button v-waves style="cursor: pointer; margin-left: 6px;padding:6px 20px;" type="danger" round @click="dialogTableClick">续费</el-button>
    </div>

    <el-dialog title="收货地址" :close-on-click-modal="false" append-to-body :visible.sync="dialogTableVisible" custom-class="pattel">
      <div slot="title" class="header-title">
        <span class="title-name">{{ defaultShop.shopName }}</span>
        <!-- <span class="title-age">{{ versionTitle }}（剩余{{ tips }}）</span> -->
        <span class="title-age">{{ versionTitle }}</span>
      </div>
      <div>38473957</div>
    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import waves from '@/directive/waves/index.js' // 水波纹指令
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  directives: {
    waves
  },
  props: ['tips', 'versionTitle', 'defaultShop'],
  data() {
    // 这里存放数据
    return {
      dialogTableVisible: false,
      shop: localStorage.getItem('shopName') || ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  beforeMount() {}, // 生命周期 - 挂载之前
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    dialogTableClick() {
      // this.dialogTableVisible = true
      // this.shop = localStorage.getItem('shopName') || ''
      window.open('https://fuwu.jinritemai.com/detail?service_id=3561&from=fuwu_market_service_list', '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.pattern {
  display: flex;
  height: 50px;
  align-items: center;
  padding-right: 3px;
  .patternCont {
    display: flex;
    // height: 50px;
    align-items: center;
    //margin-left:10px;
    width: 160px;
    .card-panel-icon {
      font-size: 24px;
      margin-right: 6px;
    }
  }
}
</style>
<style lang="scss">
.header-title {
  span {
    color: #fff;
  }
  .title-name {
    margin-right: 6px;
  }
}
.pattel {
  border-radius: 10px !important;
  width: 624px !important;
}
.pattel .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.pattel .el-dialog__header {
  border-bottom: 1px solid #e6e6e6;
  background: url('../../assets/head/head.png') no-repeat;
  background-size: 100% 100%;
}
</style>
